'use strict';
import 'url-search-params-polyfill'; // IE-11
import { noop } from 'lodash';

export default (API) => ({
    auth: {
        getAccessToken: () => {
            const url = 'v3/auth/token';
            const request = API.http.post(url);
            return API.handleError(request);
        },

        getUser: () => {
            const request = API.http.get('v3/sessions/user');
            return API.handleError(request);
        },

        getMyPatient: () => {
            const url = 'v3/resources/current';
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getMyPatientCommunication: () => {
            const url = '/v3/profile/communications';
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getAllPatients: () => {
            const url = 'v3/profile/patients';
            const request = API.http.get(url);
            return API.handleError(request);
        },

        login: (username, password) => {
            let params = new URLSearchParams();
            params.append('username', username);
            params.append('password', password);

            const request = API.http.post('v3/login', params);
            return API.handleError(request);
        },

        loginWithMfa: (params) => {
            const request = API.http.post('v3/login/mfa', params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },

        validateMfaLogin: (params) => {
            const request = API.http.post('v3/login/validateMfaLogin', params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },

        resendMfaCode: (params) => {
            const request = API.http.post('v3/login/resendMfaCode', params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },

        logout: () => {
            const request = API.http.get('v3/logout');
            return API.handleError(request);
        },

        logoutJwt: async() => {
            const request = API.http.post('v3/auth/logout').catch((reason) => {
                /**
                 * Catch here so we don't want to stop the log out execution process.
                 * Note:
                 * - Error code 401 or 403 or error containing 'refresh token call has failed' are expected when token has been invalidated elsewhere.
                 *   (e.g.: from the profile app)
                 */
                return noop();
            });

            return API.handleError(request);
        },

        heartbeat: () => {
            const request = API.http.post('v3/heartbeat');
            return API.handleError(request);
        },

        passwordResetRequest: (params) => {
            const request = API.http.post('v3/passwordResetRequest', params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        passwordKeycloakResetRequest: (params) => {
            const request = API.http.post('/v3/oauth/resetPasswordLink', params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        passwordResetValidate: (params) => {
            const request = API.http.post('v3/passwordResetValidate', params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },

        passwordReset: (params) => {
            const request = API.http.post('v3/passwordReset', params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },

        passwordUpdate: (params) => {
            const request = API.http.post('v3/passwordUpdate', params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
    },
});
